export default [
  {
    path: "/field5ydhzzj", // 无视频
    name: "field5ydhzzj",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field5ydks")
  },
  {
    path: "/field8ydhzzj", // 无视频
    name: "field8ydhzzj",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field8ydks")
  },
  {
    path: "/field9ydhzzj",
    name: "field9ydhzzj",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field9ydks")
  },
  {
    path: "/field12ydhzzj", // 无视频
    name: "field12ydhzzj",
    meta: {
      title: "企业视频彩铃",
      isKeepLive: false,  // 是否缓存
      isBack: false  // 返回效果
    },
    component: () => import("@/views/kaisa/field12ydks")
  }
];



// WEBPACK FOOTER //
// ./src/router/modules/hzzj.js